<template>
  <div id="app">
    <dy-nav-bar></dy-nav-bar>
    <div style="padding-left: 25%;">
      <dy-table v-show="isTableDisplayed == true" :ads="ads"></dy-table>
      <dy-preloader v-show="isPreloaderDisplayed == true"></dy-preloader>
    </div>
  </div>
</template>

<script>
import Table from "./components/Table.vue";
import NavBar from "./components/NavBar.vue";
import Login from "./components/Login.vue";
import Preloader from "./components/Preloader.vue";
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AdsJson from "./components/ads.json";
import axios from "axios";

export default {
  name: "app",
  data() {
    return {
      ads: [],
      isTableDisplayed: false,
      isPreloaderDisplayed: false
    };
  },
  components: {
    dyTable: Table,
    dyNavBar: NavBar,
    dyLogin: Login,
    dyPreloader: Preloader
  },
  methods: {
    loadAds() {
      if (this.isValidateLogin()) {
        this.loadProgressBar();
      }

      // this.showTable();
    },
    loadProgressBar() {
      console.log("progress bar here");
      setTimeout(() => {
        this.isPreloaderDisplayed = false;
        this.showTable();
      }, 3000);
      this.isPreloaderDisplayed = true;
    },
    isValidateLogin() {
      console.log("validation here");
      // 1 check if password and email enteded, if not - css red
      // 2 check if email in valid format, if not - css red
      return true;
    },
    showTable() {
      this.isTableDisplayed = true;

      // this.ads = AdsJson;
      axios
        .get("http://localhost:8080/ads")
        .then(response => (this.ads = response.data))
        .catch(() => console.log("Error retriving JSOM from api"));

      // start preloder until receive response from endpoint
      // use creaiglist credentials login with selenium
      // get enpoint with all the ads
    },
    repostAds() {
      // 1 post JSON to endpoint
    },
    getReport() {
      // check get endt point and update UI
    }
  }
};
</script>

<style>
.btn {
  background-color: rgb(208, 179, 255);
}
.btn:hover {
  background-color: rgb(131, 68, 233);
}
.material-icons {
  padding: 0px;
}

.a {
  border: 1px solid red;
}
.b {
  border: 1px solid blue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue